import { type FormEvent, useRef, useState } from 'react'
import { Link, Navigate } from 'react-router'

import { errorDelCampo } from '../../api/cuenta'
import { ErrorDeLaApi, pedir } from '../../api/nucleo'
import { PantallaDeAcceso } from '../../componentes/Acceso'
import { Aviso, Boton, Campo } from '../../componentes/ui'
import { marca } from '../../marca/marca'

/**
 * «Crear una cuenta» en el panel de una agencia que lo permite (CLAUDE.md §36, R6; núcleo:
 * `src/revendedores/registro.ts`). Se piden nombre, correo y negocio; el núcleo manda un enlace al correo y no
 * crea nada hasta que se abre. Lleva un campo trampa y la hora a la que se abrió, como los formularios de las webs.
 */
export const CrearCuenta = () => {
  const abierto = useRef(Date.now())
  const [nombre, setNombre] = useState('')
  const [email, setEmail] = useState('')
  const [cuenta, setCuenta] = useState('')
  const [trampa, setTrampa] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [hecho, setHecho] = useState<null | string>(null)
  const [fallo, setFallo] = useState<unknown>(null)
  const m = marca()
  if (!m?.registro) return <Navigate replace to="/entrar" />

  const enviar = async (e: FormEvent) => {
    e.preventDefault()
    setEnviando(true)
    setFallo(null)
    try {
      const r = await pedir<{ mensaje: string }>('/publico/agencia/registro', { metodo: 'POST', cuerpo: { nombre, email, cuenta, mc_no_rellenar: trampa, mc_abierto_en: abierto.current }, toleraAnonimo: true })
      setHecho(r.mensaje)
    } catch (error) {
      setFallo(error)
    } finally {
      setEnviando(false)
    }
  }

  if (hecho) {
    return (
      <PantallaDeAcceso>
        <h1 className="font-display text-[26px] font-semibold tracking-tight">Mira tu correo</h1>
        <p className="mt-3 text-sm text-tenue">{hecho}</p>
      </PantallaDeAcceso>
    )
  }

  const general = fallo && !errorDelCampo(fallo, 'email') && !errorDelCampo(fallo, 'nombre') && !errorDelCampo(fallo, 'cuenta') ? (fallo instanceof ErrorDeLaApi ? fallo.message : 'No hemos podido conectar. Comprueba tu conexión y vuelve a intentarlo.') : null
  return (
    <PantallaDeAcceso>
      <form onSubmit={enviar}>
        <h1 className="font-display text-[28px] font-semibold tracking-tight">Crea tu cuenta</h1>
        <p className="mt-2 text-sm text-tenue">Te mandamos un enlace al correo para que elijas tu contraseña.</p>
        <div className="mt-8 flex flex-col gap-4">
          <Campo autoComplete="name" autoFocus error={errorDelCampo(fallo, 'nombre')} etiqueta="Tu nombre" onChange={(e) => setNombre(e.target.value)} required value={nombre} />
          <Campo autoComplete="email" error={errorDelCampo(fallo, 'email')} etiqueta="Correo" onChange={(e) => setEmail(e.target.value)} required type="email" value={email} />
          <Campo autoComplete="organization" error={errorDelCampo(fallo, 'cuenta')} etiqueta="Nombre de tu negocio" onChange={(e) => setCuenta(e.target.value)} required value={cuenta} />
          {/* El campo trampa: una persona no lo ve; un robot lo rellena. */}
          <div aria-hidden className="h-0 w-0 overflow-hidden">
            <label>
              No rellenar
              <input autoComplete="off" className="h-0 w-0" name="mc_no_rellenar" onChange={(e) => setTrampa(e.target.value)} tabIndex={-1} value={trampa} />
            </label>
          </div>
          {general && <Aviso tono="error">{general}</Aviso>}
          <Boton cargando={enviando} className="w-full" tipo="primario" type="submit">
            Enviarme el enlace
          </Boton>
          <Link className="self-center text-[13px] text-violeta hover:underline" to="/entrar">
            Ya tengo cuenta
          </Link>
        </div>
      </form>
    </PantallaDeAcceso>
  )
}
